export const PromptsList = [
  {
    label: 'Create a social media calendar',
    value: 'media-calendar',
    desc: 'Create a social media calendar for [Product / Service name], a [Product / Service Type].Plan for [Period of time] and include different interactive and engaging posts.Account for industry - specific dates for targeted content.',
  },
  {
    label: 'Create a content strategy',
    value: 'content-strategy',
    desc: 'Create a content strategy for [Product/Service name], for our brand [Name], targeting [Target audience] to achieve [Content goals].',
  },
  {
    label: 'Create a sales strategy',
    value: 'sales-strategy',
    desc: 'Create a sales strategy for [Business name] targeting [Target Customer] with [Sales channels] to achieve [Sales goals].',
  },
  {
    label: 'Develop social media marketing strategy',
    value: 'marketing-strategy',
    desc: 'Develop social media marketing strategy for [Brand name] targeting [Target audience] using [Social media platforms] to increase brand awareness by 20% in Q3.',
  },
  {
    label: 'Develop SEO Checklist',
    value: 'seo-checklist',
    desc: 'Develop SEO Checklist for [Website name] targeting [Target audience]. Prioritize on-page (keywords, titles, images, linking, content) & technical SEO (speed, mobile, robots, structured data) for improved ranking & organic traffic.',
  },
  {
    label: 'Create a nurturing email sequence',
    value: 'email-sequence',
    desc: 'Create a nurturing email sequence for [Company name] that personalizes messages and guides leads through the [Buying/Retention/Subscription] journey.',
  },
  {
    label: 'Create a campaign checklist',
    value: 'campaign-checklist',
    desc: 'Create a [Campaign type] campaign checklist for [Brand/Product name]. Add aspects like generating guidelines for the campaign, budgets, and influencer outreach.',
  },
  {
    label: 'Generate a content review checklist',
    value: 'content-review',
    desc: 'Generate a content review checklist for my website [URL] that assesses clarity, checks copyright and data privacy issues, has a clear target audience, SEO, UX, brand consistency, comprehensiveness, CTAs, accessibility, and suggests relevant resources for improvement.',
  },
  {
    label: 'Chart out a sales pipeline',
    value: 'sales-pipeline',
    desc: 'Chart out a sales pipeline for [Brand/Product] in [Industry] for [target audience]. Ensure there are defined stages, and key touchpoints for nurturing leads.',
  },
  {
    label: 'Draft a comprehensive checklist',
    value: 'comprehensive-checklist',
    desc: 'Draft a comprehensive checklist to assist in planning a successful [type of event] for [number of guests] with a captivating [theme] for [Brand/Company]. The checklist should encompass crucial aspects like guest management, venue selection, catering options, thematic decorations, engaging entertainment, activity scheduling, and a realistic budget with logistical considerations.',
  },
];
